import { useState, useEffect } from 'react';
import { differenceInMinutes } from 'date-fns';

/**
 * Minutos decorridos desde `dataInicioExecucao`, tiquetaqueando a cada 60s
 * SÓ quando `status === 'em_execucao'`. Caso contrário (ou sem data) devolve 0.
 */
export function useMinutosExecucao(
  dataInicioExecucao: string | null | undefined,
  status: string,
): number {
  const [minutos, setMinutos] = useState(0);

  useEffect(() => {
    if (status !== 'em_execucao' || !dataInicioExecucao) {
      setMinutos(0);
      return;
    }
    const calcular = () => Math.max(0, differenceInMinutes(new Date(), new Date(dataInicioExecucao)));
    setMinutos(calcular());
    const interval = setInterval(() => setMinutos(calcular()), 60_000);
    return () => clearInterval(interval);
  }, [dataInicioExecucao, status]);

  return minutos;
}
